// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCUKqdzT2KEhwRkezItYMvxLqIoLNgSlo8",
  authDomain: "rrc-mapping.firebaseapp.com",
  databaseURL: "https://rrc-mapping-default-rtdb.firebaseio.com",
  projectId: "rrc-mapping",
  storageBucket: "rrc-mapping.appspot.com",
  messagingSenderId: "459636132099",
  appId: "1:459636132099:web:b5e6d6b3c1576e6ff38136",
  measurementId: "G-98GMC0J4JC"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const authentication = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
